module.exports = __webpack_public_path__ + "static/img/A51.33c2ed08.jpg";